import React from "react";
import { Link } from "gatsby";
import { Container } from "react-bootstrap";
import NavLinks from "./nav-links";

import logoDark from "../../assets/images/logo/jci-logo.png";

const HeaderTwo = () => {
  return (
    <div className="main-header__two">
      <div className="main-header__top">
        <Container>
          <p>Welcome to JCI India</p>
          <div className="main-header__social">
            {/* <Link to="/downloads">
              <i class="fas fa-download"></i> Downloads
            </Link> */}
            <Link to="/online-payment"><i class="fas fa-rupee-sign"></i> Payment</Link>
            <a href="https://foundation.jciindia.in/" target="_blank">
              <i class="fas fa-hand-holding-heart"></i> JCI India Foundation
            </a>
            <a href="https://seniors.jciindia.in/" target="_blank">
              <i class="fas fa-user-graduate"></i> Senior Members Association
            </a>
            <a target="_blank" href="https://members.jciindia.in/">
              <i class="fas fa-sign-in-alt"></i> Members Portal Login
            </a>
          </div>
        </Container>
      </div>
      <div className="header-upper">
        <Container>
          <div className="logo-box">
            <Link to="/">
              <img src={logoDark} width="101" alt="" />
            </Link>
            <span className="fa fa-bars mobile-nav__toggler"></span>
          </div>

          <div className="header-info">
            <div className="header-info__box">
              <i className="azino-icon-email1"></i>
              <div className="header-info__box-content">
                <h3>Email</h3>
                <p>
                  <a href="mailto:support@jciindia.in">support@jciindia.in</a>
                </p>
              </div>
            </div>
            <div className="header-info__box">
              <i className="azino-icon-calling"></i>
              <div className="header-info__box-content">
                <h3>Phone</h3>
                <p>
                  <a href="tel:022-71117112">(022)-71117112</a>
                </p>
              </div>
            </div>
            <div className="header-info__box">
              <i className="azino-address"></i>
              <div className="header-info__box-content">
                <h3>Social Links</h3>
                <div className="main-header__social">
                  <a href="#" aria-label="twitter">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href="#" aria-label="facebook">
                    <i className="fab fa-facebook-square"></i>
                  </a>
                  <a href="#" aria-label="youtube">
                    <i className="fab fa-youtube"></i>
                  </a>
                  <a href="#" aria-label="instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <nav className="main-menu">
        <Container>
          <NavLinks extraClassName="dynamic-radius" />
          {/* <Link className="thm-btn dynamic-radius" to="/contact">
            Donate Now
          </Link> */}
        </Container>
      </nav>
    </div>
  );
};

export default HeaderTwo;
